<script>
  import { Button, Dialog } from 'smelte';
  import { onMount } from 'svelte';
  import { storedSignatureHash, exportSigner } from "store";
  // https://developer.mozilla.org/en-US/docs/Web/API/Touch_events
  
  let canvasElement;
  let sketchElement;
  let ctx = null;
  let showConfirmDialog = false;

  let mouse = {x: 0, y: 0};
  let last_mouse = {x: 0, y: 0};
  let painting = false;
  let color = "#0000FF";

  onMount(() => {
    ctx = canvasElement.getContext('2d');
    if ($storedSignatureHash !== null) {
      let image = new Image();
      image.onload = function() {
        ctx.drawImage(image, 0, 0);
      }
      image.src = $storedSignatureHash;
    }
    let sketch_style = getComputedStyle(sketchElement);
    canvasElement.width = parseInt(sketch_style.getPropertyValue('width'));
    canvasElement.height = parseInt(sketch_style.getPropertyValue('height'));

    ctx.lineWidth = 3;
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.strokeStyle = 'blue';
	});

  let ongoingTouches = [];

  function resetCanvas() {
    ctx.clearRect(0, 0, canvasElement.width, canvasElement.height);
    updateStoredSignature();
  }

  function updateStoredSignature() {
    storedSignatureHash.set(canvasElement.toDataURL());
  }

  function mouseMove(e) {
    last_mouse.x = mouse.x;
		last_mouse.y = mouse.y;
		mouse.x = e.pageX - this.offsetLeft;
		mouse.y = e.pageY - this.offsetTop;
  }

  function mouseUp(e) {
    painting = false;
    updateStoredSignature();
  }
  function mouseDown(e) {
    e.preventDefault();
    painting = true;
  }

  function onPaint(e) {
    e.preventDefault();
    if (painting == true) {
      ctx.beginPath();
      ctx.moveTo(last_mouse.x, last_mouse.y);
      ctx.lineTo(mouse.x, mouse.y);
      ctx.closePath();
      ctx.stroke();
    }
  }
  
  function touchDown(e) {
    e.preventDefault();
    let touches = e.changedTouches;
    last_mouse.x = touches[i].pageX
    last_mouse.y = touches[i].pageY;
    mouse.x = e.pageX - this.offsetLeft;
		mouse.y = e.pageY - this.offsetTop;
  }

  function touchStart(e) {
    e.preventDefault();
    let touches = e.changedTouches;
    for (let i = 0; i < touches.length; i++) {
      ongoingTouches.push(copyTouch(touches[i]));
    }
  }

  function touchMove(e) {
    e.preventDefault();
    let touches = e.changedTouches;
    for (let i = 0; i < touches.length; i++) {
      let idx = ongoingTouchIndexById(touches[i].identifier);
      if (idx >= 0) {
        // only draw if still inside canvasarea otherwise ignore
        ctx.beginPath();
        ctx.moveTo(ongoingTouches[idx].pageX - this.offsetLeft, ongoingTouches[idx].pageY - this.offsetTop);
        ctx.lineTo(touches[i].pageX- this.offsetLeft, touches[i].pageY - this.offsetTop);
        ctx.closePath();
        ctx.stroke();
        ongoingTouches.splice(idx, 1, copyTouch(touches[i]));
      }
    }
  }

  function touchEnd(e) {
    e.preventDefault();
    let touches = e.changedTouches;
    for (let i = 0; i < touches.length; i++) {
      let idx = ongoingTouchIndexById(touches[i].identifier);
      if (idx >= 0) {
        ongoingTouches.splice(idx, 1);  // remove it; we're done
      } else {
        // console.log("can't figure out which touch to end");
      }
      updateStoredSignature();
    }
  }

  function touchCancel(e) {
    e.preventDefault();
    let touches = e.changedTouches;
    for (let i = 0; i < touches.length; i++) {
      let idx = ongoingTouchIndexById(touches[i].identifier);
      ongoingTouches.splice(idx, 1);  // remove it; we're done
    }
    updateStoredSignature();
  }

  function copyTouch({ identifier, pageX, pageY }) {
    return { identifier, pageX, pageY };
  }

  function ongoingTouchIndexById(idToFind) {
    for (var i = 0; i < ongoingTouches.length; i++) {
      var id = ongoingTouches[i].identifier;
      if (id == idToFind) {
        return i;
      }
    }
    return -1;    // not found
  }

  // reset signature, confirm
  function clearSignature() {
    ctx.clearRect(0, 0, canvasElement.width, canvasElement.height);
  }
</script>

<main on:touchcancel={mouseUp}>
  <div id="log"></div>
  <div class="mb-2">
    <h1 class="font-bold">
      Handtekening {#if $exportSigner}- {$exportSigner}{/if}
    </h1>
    <div id="sketch" bind:this={sketchElement} style="height: 250px;">
      <canvas id="paint" bind:this={canvasElement} on:mousemove={mouseMove} on:mousemove={onPaint} on:mouseup={mouseUp} on:mousedown={mouseDown} on:touchstart={touchStart} on:touchend={touchEnd} on:touchmove={touchMove} on:touchcancel={touchCancel}></canvas>
    </div>
  </div>
</main>
<Dialog bind:value={showConfirmDialog}>
  <h5 slot="title">Weet je het zeker?</h5>
  <div class="text-gray-700">Wil je de handtekening wissen en opnieuw plaatsen?</div>
  <div slot="actions">
    <Button text on:click={() => showConfirmDialog = false} on:click={resetCanvas}>Ja, opnieuw plaatsen</Button>
    <Button text on:click={() => showConfirmDialog = false}>Nee, bewaar huidige</Button>
  </div>
</Dialog>
<div class="mb-1">
  <Button on:click={() => showConfirmDialog = true}>Handtekening wissen</Button>
</div>

<style>
  #sketch {
    border: 1px solid black;
    border-radius: 4px;
    padding: 0;
  }

  #paint {
    width: 100%;
    height: 100%;
  }

</style>